import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Process from "../components/Process";
import AnimatedBack from "../images/AnimatedBack.gif";
import AnimatedCrm from "../images/AnimatedCrm2.gif";
import AnimatedSupport from "../images/AnimatedSupport2.gif";

const services = [
  {
    title: "Swift problem resolution",
    desc: "Our advanced technology and expertise enable us to identify and resolve issues 40% faster, ensuring efficient and accurate first-time solutions.",
  },
  {
    title: "Quality and value of service",
    desc: "We offer exceptional service that not only adds significant value to the product or application but also ensures a smooth, hassle-free experience for the client.",
  },
  {
    title: "Capabilities for innovation",
    desc: "Backed by over 14 years of IT experience, we’ve tackled a wide range of IT challenges and have the proven expertise to resolve them quickly and effectively.",
  },
  {
    title: "Global reach and impact",
    desc: "We provide comprehensive software development support and maintenance in over 60 languages, serving clients in more than 100 countries worldwide.",
  },
  {
    title: "Effective tools",
    desc: "We utilize Atlassian products such as JIRA to offer top-tier support, swift bug resolutions, and exceptional responsiveness for mission-critical issues.",
  },
  {
    title: "Imaginative thinking",
    desc: "To remedy the problem, we use a lot of data and research to predict how much more help will be needed after 6 months.",
  },
  {
    title: "Proactive support",
    desc: "In the cognitive era, we take a proactive approach to meeting your IT needs, delivering integrated support and efficient remote solutions to ensure seamless operations.",
  },
  {
    title: "24/7 service availability",
    desc: "By operating across multiple time zones, we are always prepared to resolve our clients' issues promptly, no matter when they arise.",
  },
];

function SupportMain() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <div className="GD">
        {/* Hero Section */}
        <div className="Webd-above">
          <img className="Webd-img" src={AnimatedBack} alt="Background" />
          <div className="Webd-above-info">
            <p className="Webd-p">IT Support</p>
            <p
              className="Webd-p"
              style={{ marginTop: "10px", marginBottom: "20px" }}
            >
              & Maintenance
            </p>
            <p className="Webd-p1">
              Flexible, scalable, and cost-effective software maintenance
              services to boost your productivity.
            </p>
          </div>
        </div>

        {/* Content Section */}
        <div className="Gd-main" style={{ textAlign: "center" }}>
          <h2
            className="Gd-main-p"
            style={{
              fontSize: "34px",
              color: "black",
              marginBottom: "40px",
              fontWeight: "bolder",
            }}
          >
            IT Management Services
          </h2>

          <p className="Gd-main-p">
            Our IT maintenance services seamlessly integrate advanced management
            technologies with highly skilled resources to provide your
            organization with comprehensive evaluations and proactive solutions.
            By identifying and addressing potential issues early, we help
            prevent minor concerns from turning into significant disruptions. At
            the heart of our approach is a commitment to our clients’ needs and
            preferences. We deliver unparalleled after-sales support, ensuring
            smooth operations, enhanced efficiency, and complete peace of mind
            for our clients.
          </p>

          {/* Support Image */}
          <img
            src={AnimatedSupport}
            alt="Support"
            style={{
              display: "block",
              margin: "40px auto",
              width: "100%",
              maxWidth: "900px",
              height: "auto",
              borderRadius: "12px",
            }}
          />

          {/* Services Grid */}
          <div
  className="services-grid"
  style={
    isDesktop
      ? {
          margin: "60px",
          padding: "40px",
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)", // 4 columns
          gridGap: "30px", // spacing between items
        }
      : {
          display: "grid",
          gridTemplateColumns: "1fr", // mobile = 1 column
          gridGap: "20px",
        }
  }
>
  {services.map((service, index) => (
    <div
      className="Appd-main2-box"
      key={index}
      style={
        isDesktop
          ? { padding: "20px" } // spacing desktop
          : { padding: "10px" } // smaller on mobile
      }
    >
      <img
        className="Crm-main3-img"
        src={AnimatedCrm}
        alt="Service"
        style={{ maxWidth: "120px", height: "auto", margin: "0 auto" }}
      />
      <p className="service-title">{service.title}</p>
      <p className="service-desc">{service.desc}</p>
    </div>
  ))}
</div>

        </div>

        <Process />
        <Footer />
      </div>
    </>
  );
}

export default SupportMain;
